import { useEffect, useRef, useState } from "react";
import { AWS_BASE_URL, DOMAIN_URL } from "../../../../../clientConfig";
import { getSimilarProjects } from "../../../../../services/customer/home";
import SplideSlider from "../../../../../components/Slider/SplideSlider";
import ProjectCard from "../../../../../components/Card/ProjectCard/ProjectCard";
import {
  saveProject,
  unSaveProject,
} from "../../../../../services/customer/project";
import { handleShowProjectPrice } from "../../../../../utils";
import SharedModel from "../../../../../components/Share/SharedModel";
import CustomerReport from "../../../../../components/Section/Report/CustomerReport";
import { useParams } from "react-router-dom";

interface IProps {
  category_id: string;
  handleDataRef?: any;
  showItems?: number;
  breakpoints?: any;
  // handleDropdownActions?: (item: any) => void;
  handleModalAuthOpen?: () => void;
}

const SimilarProjectSection: React.FC<IProps> = ({
  category_id,
  handleDataRef,
  showItems = 4,
  breakpoints,
  handleModalAuthOpen,
}) => {
  const { projectId } = useParams();
  const hasFetchedData = useRef(false);
  const [projectList, setProjectList] = useState<any[]>([]);
  const [savedProjects, setSavedProjects] = useState<string[]>([]);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const [shareModal, setShareModal] = useState<any>({
    id: "",
    slug: "",
    show: false,
  });
  const [reportModal, setReportModal] = useState<any>({
    id: "",
    show: false,
  });

  const handleData = (data: any) => {
    const listData = data?.list
      ?.filter((project: any) => project?._id !== projectId)
      ?.map((project: any) => {
        const buildings = [
          ...new Set(
            project?.buildings
              ?.map((building: any) => building?.building_type)
              ?.filter((building_type: any) => building_type !== 0)
              ?.sort()
          ),
        ];
        const description = project?.type_project
          ? `${buildings?.join(
              "-"
            )} ${buildings?.length ? "BHK" : ""}  ${buildings?.length ? (project?.project_type ? "House" : "Apartment") : ""}  ${
              project?.amenities_length
                ? `${buildings?.length ? "With" : ""} ` +
                  project?.amenities_length +
                  " Amenities"
                : ""
            }`
          : "";
        return {
          id: project?._id,
          imageUrl: project?.project_images?.images?.[0]?.image
            ? `${AWS_BASE_URL}${project?.project_images?.images?.[0]?.image}`
            : null,
          profileUrl: project?.logo ? `${AWS_BASE_URL}${project?.logo}` : null,
          title: project?.name,
          location: project?.location,
          price: handleShowProjectPrice(project?.buildings),
          content: description,
          link: `/project-information/${project?.slug}/${project?._id}`,
          slug: project?.slug,
          is_saved: project?.is_saved,
        };
      });

    const savedProjectIds =
      data?.list
        ?.filter((project: any) => project?.is_saved)
        ?.map((project: any) => project?._id) || [];

    setProjectList(listData);
    setSavedProjects(savedProjectIds);
  };

  useEffect(() => {
    if (!hasFetchedData.current) {
      getSimilarProjects(handleData, () => {}, {
        page: 1,
        limit: 10,
        category_id,
      });
      hasFetchedData.current = true;
    }
  }, [projectId]);

  return projectList?.length ? (
    <div className="similar-project-section p-4 space-y-8">
      <div className="flex-1">
        <h2 className="text-center font-normal text-3xl md:text-4xl text-dark-cyan">
          Similar <span className="font-black">Projects</span>
        </h2>
      </div>
      <div className="sm:px-4">
        <div className="project-list">
          <SplideSlider
            showItems={showItems}
            options={{
              pagination: false,
              gap: "10px",
              breakpoints: {
                1650: {
                  perPage: 4,
                  perMove: 4,
                },
                1200: {
                  perPage: 3,
                  perMove: 3,
                },
                1024: {
                  perPage: 2,
                  perMove: 2,
                },
                768: {
                  perPage: 1,
                  perMove: 1,
                },
                ...breakpoints,
              },
            }}
          >
            {projectList?.map((project, index) => (
              <ProjectCard
                key={index}
                {...project}
                handleDataRef={handleDataRef}
                navigationClick={() => (hasFetchedData.current = false)}
                handleWithOutLogin={handleModalAuthOpen}
                saveAction={{
                  show: true,
                  checked: savedProjects?.includes(project?.id) ? true : false,
                  loading: saveLoading,
                  onClick: () => {
                    setSaveLoading(true);
                    if (savedProjects?.includes(project?.id)) {
                      unSaveProject(project?.id, setSaveLoading, () => {
                        const filterProperties = savedProjects?.filter(
                          (savedProject) => project?.id !== savedProject
                        );
                        setSavedProjects(filterProperties);
                      });
                    } else {
                      saveProject(project?.id, setSaveLoading, () => {
                        setSavedProjects((prev: any) => [...prev, project?.id]);
                      });
                    }
                  },
                }}
                actionMenu={[
                  {
                    key: "share",
                    value: "Share",
                    id: project?.id,
                    slug: project?.slug,
                  },
                  {
                    key: "report",
                    value: "Report",
                    id: project?.id,
                  },
                ]}
                handleDropdownActions={(item: any) => {
                  if (item?.key === "share") {
                    setShareModal({
                      id: item?.id,
                      slug: item?.slug,
                      show: true,
                    });
                  } else if (item?.key === "report") {
                    setReportModal({ id: item?.id, show: true });
                  }
                }}
              />
            ))}
          </SplideSlider>
        </div>
      </div>

      <SharedModel
        shareLink={`${DOMAIN_URL}project-information/${shareModal?.slug}/${shareModal?.id}`}
        showModal={shareModal?.show}
        closeModal={() => setShareModal({ id: "", show: false })}
      />
      <CustomerReport
        initialData={{ project_id: reportModal.id ?? "" }}
        closeModal={() => setReportModal({ id: "", show: false })}
        showModal={reportModal.show}
      />
    </div>
  ) : null;
};

export default SimilarProjectSection;
